import { Injectable } from '@angular/core';
import { FeatureType } from 'src/app/models/enums';
import { UtilsService } from '../utils/utils.service';

@Injectable({
  providedIn: 'root'
})
export class DeleteOptions {

  constructor(private utilsService: UtilsService) {}

  removeElement(map: google.maps.Map, id: any, type: FeatureType): void {
    const feature = this.utilsService.findFeatureByPropertyId(map.data, id, type);
    if (feature) {
      map.data.remove(feature);
    }
  }

}
